import { render } from "./MonitorSchematic.vue?vue&type=template&id=a7d4c0a6"
import script from "./MonitorSchematic.vue?vue&type=script&lang=js"
export * from "./MonitorSchematic.vue?vue&type=script&lang=js"

import "./MonitorSchematic.vue?vue&type=style&index=0&id=a7d4c0a6&lang=css"
script.render = render

export default script